import { Layout } from "antd";
import { Outlet } from "react-router-dom";

const DefaultLayout = () => {
  return (
    <Layout className="h-screen bg-white">
      <Outlet />
    </Layout>
  );
};

export default DefaultLayout;
